import React from "react";
import "./SuccessAnimation.css";

const SuccessAnimation = () => {
  return (
    <div className="hf-success-container">

      {/* Ripple Rings */}

      <div className="hf-ring hf-ring1"></div>
      <div className="hf-ring hf-ring2"></div>
      <div className="hf-ring hf-ring3"></div>

      {/* Success Circle */}

      <div className="hf-success-circle">

        <svg
          className="hf-check-svg"
          viewBox="0 0 52 52"
        >

          <circle
            className="hf-check-circle"
            cx="26"
            cy="26"
            r="25"
            fill="none"
          />

          <path
            className="hf-check-path"
            fill="none"
            d="M14 27 L22 35 L38 18"
          />

        </svg>

      </div>

      {/* Floating Icons */}

      <div className="hf-float hf-float1">🍲</div>
      <div className="hf-float hf-float2">🥘</div>
      <div className="hf-float hf-float3">🍛</div>
      <div className="hf-float hf-float4">🍽️</div>

    </div>
  );
};

export default SuccessAnimation;